// This file was generated by [ts-rs](https://github.com/Aleph-Alpha/ts-rs). Do not edit this file manually.

/**
 * Describes the latest stage reached by a running background task.
 *
 * This type is used internally and also crosses the document-updates WebSocket
 * boundary. Serde defines its wire values and `ts-rs` generates the matching frontend
 * enum, preventing display formatting from becoming an accidental protocol.
 */
export enum BgTaskStatus {
  reading = 'reading',
  reading_thread = 'reading_thread',
  abstain = 'abstain',
  researching = 'researching',
  web_searching = 'web_searching',
  web_fetching = 'web_fetching',
  searching_offers = 'searching_offers',
  analyzing_search_results = 'analyzing_search_results',
  fetching_offer_details = 'fetching_offer_details',
  fetching_reviews = 'fetching_reviews',
  loading_site_info = 'loading_site_info',
  reformulating_query = 'reformulating_query',
  reformulating_offer_title = 'reformulating_offer_title',
  recommending = 'recommending',
  replying = 'replying',
  answered = 'answered',
  replied = 'replied',
  completed = 'completed',
  failed = 'failed',
  writing_guides = 'writing_guides',
}
